import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit, input } from '@angular/core';
import { DotCMSNavigationItem } from 'dotcms/src/lib/models';
import { Observable } from 'rxjs';

import { MAIN_NAVIGATION_MAX_SUB_CATEGORIES_DEPTH } from 'ish-core/configurations/injection-keys';
import { AppFacade } from 'ish-core/facades/app.facade';
import { DeviceType } from 'ish-core/models/viewtype/viewtype.types';
import { InjectSingle } from 'ish-core/utils/injection';

import { dotCMSNavigationLink, isIndexPagePresent } from '../../utils/dot-cms-uve-utils';

import { DotCmsUVEDesktopViewHeaderNavigationComponent } from './dot-cms-uve-desktop-view-header-navigation/dot-cms-uve-desktop-view-header-navigation.component';
import { DotCmsUVEGeneralViewHeaderNavigationComponent } from './dot-cms-uve-general-view-header-navigation/dot-cms-uve-general-view-header-navigation.component';

@Component({
  selector: 'custom-dot-cms-uve-header-navigation',
  templateUrl: './dot-cms-uve-header-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, DotCmsUVEDesktopViewHeaderNavigationComponent, DotCmsUVEGeneralViewHeaderNavigationComponent],
})
export class DotCmsUVEHeaderNavigationComponent implements OnInit {
  navLinks = input.required<DotCMSNavigationItem>();

  // navLinks$: Observable<DotCMSNavigationItem>;
  dotCMSHeaderNavigationLink = dotCMSNavigationLink;
  isHavingIndexPage = isIndexPagePresent;
  openedPages: DotCMSNavigationItem[] = [];
  deviceType$: Observable<DeviceType>;
  constructor(
    private appFacade: AppFacade,
    @Inject(MAIN_NAVIGATION_MAX_SUB_CATEGORIES_DEPTH)
    public mainNavigationMaxSubFoldersDepth: InjectSingle<typeof MAIN_NAVIGATION_MAX_SUB_CATEGORIES_DEPTH>
  ) {}
  ngOnInit() {
    // this.navLinks$ = this.dotCmsFacade.fetchHeaderLinks$();
    this.deviceType$ = this.appFacade.deviceType$;
  }
}
